import React from 'react';
import classnames from 'classnames';

const ProgressBar = (props) => {
  const { bgcolor, completed, className, progress } = props;
  const pageCssBEM = 'progressBar';
  const classes = classnames(pageCssBEM, className);
  const wholeNumberProgress = Math.floor(progress);


  const progressBarCompletion = {
    width: `${wholeNumberProgress}%`,
  }

  return (
    <div className={classes}>
      <div className={`${pageCssBEM}__inner`} style={progressBarCompletion}></div>
    </div>
  );
};

export default ProgressBar;
